module.exports = __webpack_public_path__ + "static/media/high-school.0947530b.png";